/**
 * Tipo de documento de una persona según su número (MineTrace.Shared.Enums.PersonDocumentType).
 * El buscador de contactos acepta DNI (8 dígitos) o CE (9-12 alfanuméricos), pero el alta
 * enviaba siempre documentType 1: un contacto con CE quedaba guardado como DNI y la tarjeta
 * decía "DNI 000099072".
 */
export const PERSON_DOCUMENT_TYPE = { Dni: 1, Ce: 2, Passport: 3 } as const

export function documentTypeFromNumber(doc: string | null | undefined): number {
  return /^\d{8}$/.test((doc ?? '').trim()) ? PERSON_DOCUMENT_TYPE.Dni : PERSON_DOCUMENT_TYPE.Ce
}

export function documentTypeLabel(doc: string | null | undefined): string {
  return documentTypeFromNumber(doc) === PERSON_DOCUMENT_TYPE.Dni ? 'DNI' : 'CE'
}
